import { axios } from 'src/api'
import { ApiUpdateRateRestrictionsParams, ApiUpdateRateRestrictionsResponse } from './updateraterestrictions.types'

export const apiUpdateRateRestrictions = ({ serverPath, data }:ApiUpdateRateRestrictionsParams) => {
  return axios.post<ApiUpdateRateRestrictionsResponse>(
    `https://${serverPath}/sialdPMS/web/resourcescrossorigin/seasonmanual/updateraterestrictions`,
    data
  )
}
